export const GET_MEMBER_GROUP = "GET_MEMBER_GROUP";
export const UPDATE_MEMBER_GROUP = "UPDATE_MEMBER_GROUP";
export const CREATE_MEMBER_GROUP = "CREATE_MEMBER_GROUP";
export const SHOW_MEMBER_GROUP = "SHOW_MEMBER_GROUP";
export const UPDATE_STATUS_MEMBER_GROUP = "UPDATE_STATUS_MEMBER_GROUP";
export const DELETE_MEMBER_GROUP = "DELETE_MEMBER_GROUP";
export const DROPDOWN = "MEMBER_GROUP_DROPDOWN";